export interface ProposedPlanRevision {
  readonly updatedAt: string;
  readonly implementedAt: string | null;
}

/**
 * Accepts only monotonic Proposed Plan revisions.
 *
 * Equal timestamps are duplicates unless they add the one irreversible piece of
 * information: the relationship to an implementation turn. This keeps replayed
 * or reordered provider events from replacing visible plan content or clearing
 * implementation metadata.
 */
export function shouldApplyProposedPlanUpdate(
  existing: ProposedPlanRevision | undefined,
  incoming: ProposedPlanRevision,
): boolean {
  if (!existing) {
    return true;
  }

  const timestampOrder = existing.updatedAt.localeCompare(incoming.updatedAt);
  if (timestampOrder < 0) {
    return true;
  }
  if (timestampOrder > 0) {
    return false;
  }

  return existing.implementedAt === null && incoming.implementedAt !== null;
}

export function resolveSessionSourceProposedPlan<SourceReference>(input: {
  readonly turnStartSource: SourceReference | undefined;
  readonly existingLatestTurnSource: SourceReference | undefined;
  readonly existingLatestTurnId: string | null | undefined;
  readonly activeTurnId: string | null;
}): SourceReference | undefined {
  return (
    input.turnStartSource ??
    (input.existingLatestTurnId === input.activeTurnId ? input.existingLatestTurnSource : undefined)
  );
}
